export function dedupeByEmail(contacts) {
  const seen = new Set()
  return contacts.filter((c) => {
    if (!c.email || seen.has(c.email)) return false
    seen.add(c.email)
    return true
  })
}

export function contactRow(contact) {
  const div = document.createElement("div")
  div.className = "flex items-center justify-between text-sm py-1.5 px-2 rounded hover:bg-gray-50"
  const name = document.createElement("span")
  name.className = "font-medium text-gray-900 truncate"
  name.textContent = contact.name || "—"
  const email = document.createElement("span")
  email.className = "text-gray-500 truncate ml-2"
  email.textContent = contact.email
  div.append(name, email)
  return div
}

export function emptyMessage(text) {
  const div = document.createElement("div")
  div.className = "text-sm text-gray-400 italic py-4 text-center"
  div.textContent = text
  return div
}
